import { render } from "./HeroIndex.vue?vue&type=template&id=6c1bd848"
import script from "./HeroIndex.vue?vue&type=script&lang=js"
export * from "./HeroIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__